import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { adminApi } from '@/lib/adminApi';
import { type InterventionClass } from '@/lib/boardOutput';
import { AdminPage, RegistryTable, StatusPill } from '@/admin';

export function InterventionClassesPage() {
  const q = useQuery({ queryKey: ['intervention-classes'], queryFn: () => adminApi.interventionClasses.list() });
  const [search, setSearch] = useState('');
  const rows = Object.values(q.data?.classes ?? {});

  return (
    <AdminPage title="Intervention classes" description="The categories of clinical recommendation the board may produce — each declares its candidate-payload schema and default renderer. Read-only (seed-authored).">
      {q.data ? <div className="mb-13 text-body-sm text-text-secondary">{rows.length} classes · registry v{String(q.data.version ?? '?')}</div> : null}
      <RegistryTable<InterventionClass>
        columns={[
          { key: 'class_id', header: 'Class', className: 'font-mono text-[12px]', render: (c) => c.class_id },
          { key: 'label', header: 'Label', className: 'font-medium', render: (c) => c.label },
          { key: 'default_renderer', header: 'Default renderer', className: 'font-mono text-[11px] text-text-secondary', render: (c) => c.default_renderer || '—' },
          { key: 'schema', header: 'Payload schema', className: 'text-[12px] text-text-secondary', render: (c) => `${c.candidate_payload_schema.required.length} required · ${c.candidate_payload_schema.optional.length} optional` },
          { key: 'active', header: 'Active by default', render: (c) => <StatusPill on={c.active_default} label={c.active_default ? 'active' : 'off'} /> },
          { key: 'description', header: 'Description', className: 'max-w-[380px] text-[12px] text-text-secondary', render: (c) => c.description || '—' },
        ]}
        rows={rows.filter((c) => !search || `${c.class_id} ${c.label} ${c.description}`.toLowerCase().includes(search.toLowerCase()))}
        getRowKey={(c) => c.class_id}
        count={rows.length}
        state={{ loading: q.isLoading, error: q.isError }}
        emptyText={search ? `No classes match "${search}"` : 'No intervention classes.'}
        search={{ value: search, onChange: setSearch, placeholder: 'Search classes…' }}
      />
    </AdminPage>
  );
}
